import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoryGrid from './components/CategoryGrid';
import FAQSection from './components/FAQSection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '夜桜导航 - 里番动漫 漫画 | 精选内容推荐与资源导航',
  url: 'https://yozakura-nav.example.com',
  description: '专注于里番动漫/漫画领域的內容导航平台，为成年用户提供精选作品推荐、风格分类解析、创作背景介绍及合规观看渠道指引。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://yozakura-nav.example.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategoryGrid />
        <FAQSection />
      </main>
    </>
  );
}